module.exports = "pegasus/assets/circle-pinterest.gif";